import { request } from "./Request";
import { routes } from "../constants/constant.route";

const dashBoardRoutes = routes.DASHBOARD;
const API_URL = process.env.REACT_APP_API_URL;
const {
  FILTERAPI
} = dashBoardRoutes;

export default class DashboardService {
  static getVideoUrl() {
    return request(
      "POST",
      `${API_URL}${dashBoardRoutes.VIDEO_URL}`,
      null,
      null,
      null
    );
  }

  static getReportAll(memberId, zone, year) {
    let qp = "";
    if (memberId) {
      qp = `?u=${memberId}`;
    }

    if (year && !memberId) {
      qp += `?y=${year}`;
    } else if (year && memberId) {
      qp += `&y=${year}`;
    }
    if (zone && !year && !memberId) {
      qp += `?zone=${zone}`;
    } else if (zone) {
      qp += `&zone=${zone}`;
    }
    return request(
      "GET",
      `${API_URL}${dashBoardRoutes.GET_REPORT_ALL}${qp}`,
      null,
      null,
      null
    );
  }

  static getPoints(memberId, zone, year) {
    let qp = "";
    if (memberId) {
      qp = `?u=${memberId}`;
    }
    if (zone) {
      qp += `&zone=${zone}`;
    }
    if (year) {
      qp += `&y=${year}`;
    }
    return request(
      "GET",
      `${API_URL}${dashBoardRoutes.GET_POINTS}${qp}`,
      null,
      null,
      null
    );
  }

  static getOfftakeSummary(memberId, year) {
    let qp = "";
    if (year) {
      qp += `?y=${year}`;
    }
    if (memberId) {
      qp += `&u=${memberId}`;
    }
    return request(
      "GET",
      `${API_URL}${dashBoardRoutes.GET_OFFTAKE_SUMMARY}${qp}`,
      null,
      null,
      null
    );
  }


  static getOfftakeVerificationCount(memberId, year) {
    let qp = "";
    if (memberId && memberId !== "all") {
      qp = `?u=${memberId}`;
    }
    if (memberId && memberId !== "all" && year) {
      qp += `&y=${year}`;
    } else if (!memberId && year) {
      qp += `?y=${year}`;
    }
    return request(
      "GET",
      `${API_URL}${dashBoardRoutes.OFFTAKE_VERIFICATION_COUNT}${qp}`,
      null,
      null,
      null
    );
    // return request('GET', `${API_URL}${dashBoardRoutes.OFFTAKE_VERIFICATION_COUNT}`, null, null, null);
  }

  static getRedeemData(year) {
    var qp = "?";
    if (year) {
      qp += `y=${year}`;
    }
    return request(
      "GET",
      `${API_URL}${dashBoardRoutes.GET_REDEEM_DATA}${qp}`,
      null,
      null,
      null
    );
  }

  static downloadScoreCard(filter) {
    let qp = "?";
    if (filter.y) {
      qp += `year=${filter.y}`;
    }
    return request(
      "GET",
      `${API_URL}${dashBoardRoutes.DOWNLOAD_SCORE_CARD}${qp}`,
      null,
      null,
      null
    );
  }

  static downloadHOScoreCard(filter) {
    let qp = "?";
    if (filter.y) {
      qp += `year=${filter.y}`;
    }
    return request(
      "GET",
      `${API_URL}${dashBoardRoutes.HO_DOWNLOAD_SCORE_CARD}${qp}`,
      null,
      null,
      null
    );
  }

  static downloadfleetreport() {
    return request(
      "GET",
      `${API_URL}${dashBoardRoutes.DOWNLOAD_FLEET_REPORT_SIDENAV}`,
      null,
      null,
      null
    );
  }

  static navBarToHide() {
    return request(
      "GET",
      `${API_URL}${dashBoardRoutes.NAVBAR_TOHIDE}`,
      null,
      null,
      null
    );
  }
  static getDisplayLabel(year) {
    if (year) {
      var qp = `?y=${year}`;
    }
    return request(
      "GET",
      `${API_URL}${dashBoardRoutes.GET_DISPLAY_LABEL}${qp ? qp : ""}`,
      null,
      null,
      null
    );
  }

  static getClubName(year, uuid) {
    if (year) {
      var qp = `?year=${year}`;
    }
    if (uuid) {
      qp += `&u=${uuid}`;
    }
    return request(
      "GET",
      `${API_URL}${dashBoardRoutes.GET_CLUB_NAME}${qp ? qp : ""}`,
      null,
      null,
      null
    );
  }


  static getSalesTargetAchivemet(reqData) {
    return request(
      "GET",
      `${API_URL}${routes.HODASHBOARD.SALES_TARGET_ACIVEMENT}`,
      reqData,
      null,
      null
    );
  }

  static getRedeemptionDashbaord() {
    return request("GET", `${API_URL}${dashBoardRoutes.GET_REDEEMPTION_DASHBOARD}`, null, null, null);
  }

  static filterAPI(filter) {
    let qp = "?";
    if (filter.y) {
      qp += `y=${filter.y}`;
    }
    if (filter.q) {
      qp += `&q=${filter.q}`;
    }
    if (filter.m) {
      qp += `&m=${filter.m}`;
    }
    return request("GET", `${API_URL}${FILTERAPI}${qp}`, null, null, null);
  }

  static getPrimaryPoints(userId, year) {
    let qString = ``;
    if (userId) {
      qString += `?u=${userId}`;
    }
    if (year && !userId) {
      qString = `?y=${year}`;
    } else if (year && userId) {
      qString += `&y=${year}`;
    }
    return request(
      "GET",
      `${API_URL}${dashBoardRoutes.GET_POINTS}${qString}`,
      null,
      null,
      null
    );
  }
}
